/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

import React from "react";

import { ContentItem } from "@at/design-system-patterns";

import { IContentItemRowInput } from "./get-content-item-row-data.types";
import { ContentItemRowData } from "../../children/content-item-row-data/content-item-row-data";

/** Note only object OR array data will be used. Object takes precedence. */
export const getContentItemRowData = ({
  rowHeading,
  object,
  array,
}: IContentItemRowInput): ContentItem | null => {
  if (!object && !array) return null;
  if (object) {
    const data = Object.entries(object)
      .map(([key, value]) => (key && value ? `${key} - ${value}` : null))
      .filter((data): data is string => data != null);
    if (data.length === 0) return null;
    return {
      rowHeading,
      rowContent: <ContentItemRowData rowHeading={rowHeading} data={data} />,
    };
  }
  if (array) {
    const data = array
      .map((string) => string ?? null)
      .filter((data): data is string => data != null);
    if (data.length === 0) return null;
    return {
      rowHeading,
      rowContent: <ContentItemRowData rowHeading={rowHeading} data={data} />,
    };
  }
  return null;
};
